<template>
  <div class="navigation-dialog-overlay">
    <div class="navigation-dialog-container" @click.stop>
      <!-- 헤더 -->
      <div class="navigation-dialog-header">
        <feather-icon
          v-if="useBack"
          class="menu-icon"
          icon="ChevronLeftIcon"
          @click="backDialog"
        />
        <div v-else></div>
        <span class="header-title">{{ $t(title) }}</span>
        <feather-icon
          v-if="useClose"
          class="menu-icon"
          icon="XIcon"
          @click="closeDialog"
        />
        <div v-else></div>
      </div>

      <!-- -->
      <slot/>

    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationDialog',
  props: {
    title: String,
    useBack: Boolean,
    useClose: Boolean,
  },
  data() {
    return {
    }
  },
  methods: {
    backDialog () {
      this.$emit('back')
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.navigation-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.navigation-dialog-container {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 600px;
  position: relative;
  opacity: 1 !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.navigation-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: rgba(var(--vs-primary), 1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff !important;
  position: relative;
  z-index: 100;
  opacity: 1 !important;
  backdrop-filter: none !important;
}

.header-title {
  color: #fff !important;
  font-size: 18px;
  font-weight: 600;
  opacity: 1 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  filter: none !important;
  backdrop-filter: none !important;
}

.menu-icon {
  color: #fff !important;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s;
  opacity: 1 !important;
  filter: none !important;
  backdrop-filter: none !important;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    transform: scale(1.05);
  }
}


// 모바일 최적화
@media (max-width: 768px) {
  .navigation-dialog-overlay {
    padding: 0;
    // 모바일에서 viewport 전체 사용하되 safe area 고려
    height: 100vh;
    height: 100dvh; // 동적 viewport height 사용 (지원하는 브라우저에서)
  }

  .navigation-dialog-container {
    margin: 0;
    border-radius: 0;
    height: 100vh;
    height: 100dvh; // 동적 viewport height 사용
    max-width: none;
    min-height: 100vh;
    min-height: 100dvh;
    // 상단과 하단 safe area 확보
    padding-top: env(safe-area-inset-top, 0);
    padding-bottom: env(safe-area-inset-bottom, 0);
    display: flex;
    flex-direction: column;
  }
}
</style>
